<template>
  <div style="border-bottom: 1px solid rgb(210, 213, 217)">
    <layout-content-menu :items="items" white :selected="selected" stacked />
  </div>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";
import LayoutContentMenu from "@/components/shared/layout/LayoutContentMenu.vue";
import TopMenuItemModel from "@/models/components/layout/TopMenuItemModel";
import { filterCapitalize } from "@/filters/capitalize";
import { CustomClickActionFunction } from "@/models/components/CustomClickActionFunction";

export enum ADMINISTRATION_ROLES_TABS {
  Permissions,
  Users,
}

@Component({
  components: { LayoutContentMenu },
})
export default class AdministrationRolesContentMenu extends Vue {
  clickFunction: CustomClickActionFunction = (item: TopMenuItemModel, vue) => {
    vue.$store.direct.commit.administration.roles.setSelectedTab(item.value as ADMINISTRATION_ROLES_TABS);
  };

  get selected(): ADMINISTRATION_ROLES_TABS {
    return this.$store.direct.state.administration.roles.selectedTab;
  }

  items: Array<TopMenuItemModel> = [
    {
      text: filterCapitalize(this.$t("permissionsInRole")),
      value: ADMINISTRATION_ROLES_TABS.Permissions,
      action: this.clickFunction,
    } as TopMenuItemModel,
    {
      text: filterCapitalize(this.$t("usersInRole")),
      value: ADMINISTRATION_ROLES_TABS.Users,
      action: this.clickFunction,
    } as TopMenuItemModel,
  ];
}
</script>

<style scoped></style>
